import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );
class NavigationTabs {
  constructor ( nav ) {
    this.nav = nav;
    this.navH = this.nav.offsetHeight;
    this.navIdPrefix = 'section-nav-';
    this.secIdPrefix = 'section-';
    this.navItems = this.nav.querySelectorAll( `p[id*=${this.navIdPrefix}]` );
    this.hH = document.querySelector( 'header' )?.offsetHeight || 0;
    this.clicked = false;
    this.sections = document.querySelectorAll( `section[id*=${this.secIdPrefix}]` );
    this.navColWrapper = this.nav.querySelector( '.e-col:has(.e-div--navigation-tabs-wrapper)' );
    this.isGlossary = this.nav.classList.contains( 'e-stn--glossary-nav' );
  }

  setNavItemActive( itemId ) {
    this.navItems.forEach( ( item ) => {
      item.classList.remove( 'active' );
    } );
    const activeNavItem = this.nav.querySelector( `#${this.navIdPrefix}${itemId}` );
    if ( activeNavItem ) {
      activeNavItem.classList.add( 'active' );
    }
  }

  scrollToSection ( secId ) {
    const section = document.querySelector( `section#${this.secIdPrefix}${secId}` );
    if( section ) {
      const sectionTop = section.getBoundingClientRect().top;
      window.scrollTo( {
        top: ( sectionTop + window.scrollY ) - ( this.hH + this.navH ) ,
        behavior: 'smooth'
      } );
    }
  }

  glossaryFunc ( itemId ) {
    const glossarySections = document.querySelectorAll( '.e-stn--glossary-section' );
    const glossarySrchInput = document.querySelector( '#glossary-search' );
    const noResultsEl = document.querySelector( '.e-stn--glossary-search .no-results-msg' );
    const glossaryItems = document.querySelectorAll( '.e-stn--glossary-section p' );
    if( glossarySections.length > 0 ) {
      glossarySrchInput.value = '';
      glossarySections.forEach( ( sec ) => {
        sec.style.display = 'block';
      } );
      glossaryItems.forEach( ( item ) => {
        item.style.display = 'flex';
      } );
      noResultsEl.style.display = 'none';
    } else {
      localStorage.setItem( 'selectedGlossary', itemId );
    }
  }
  glossaryScrollFunc ( secId ) {
    const glossarySections = document.querySelectorAll( '.e-stn--glossary-section' );
    if( glossarySections.length > 0 ) {
      const navHref = document.querySelector( `p#${this.navIdPrefix}${secId} a` ).href;
      window.location = navHref;
    }
  }
  glossaryHashFunc ( hash ) {
    const glossaryNavItem = this.nav.querySelector( `p[data-glossary-hash="${hash}"]` );
    if ( glossaryNavItem ) {
      localStorage.setItem( 'selectedGlossary', glossaryNavItem.id );
    }
  }
  navItemClick ( itemId ) {
    const id = itemId.split( this.navIdPrefix )[1];
    if( this.isGlossary ) {
      this.glossaryFunc( itemId );
    }
    this.setNavItemActive( id );
    this.scrollNavItem( id );
    this.clicked = true;
    this.scrollToSection( id );
  }

  navItemClickEvent () {
    this.navItems.forEach( ( navItem ) => {
      navItem.addEventListener( 'click', () => {
        const itemId = navItem.id;
        this.navItemClick( itemId );
      } );
    } );
  }

  scrollNavItem( itemId ) {
    const activeNavItem = this.nav.querySelector(
      `#${this.navIdPrefix}${itemId}`
    );
  
    if ( !activeNavItem || !this.navColWrapper ) return;
  
    const itemRect = activeNavItem.getBoundingClientRect();
    const wrapperRect = this.navColWrapper.getBoundingClientRect();
    const maxScrollLeft =
      this.navColWrapper.scrollWidth - this.navColWrapper.clientWidth;
  
    const targetLeft =
      this.navColWrapper.scrollLeft +
      itemRect.left -
      wrapperRect.left -
      ( wrapperRect.width - itemRect.width ) / 2;
  
    this.navColWrapper.scrollTo( {
      left: Math.max( 0, Math.min( targetLeft, maxScrollLeft ) ),
      behavior: 'smooth'
    } );
  }

  setSectionActive ( section ) {
    this.sections.forEach( ( sec ) => {
      sec.classList.remove( 'active' );
    } );
    section.classList.add( 'active' );
    const secId = section.id.split( this.secIdPrefix )[1];
    if( !this.clicked ) {
      this.setNavItemActive( secId );
      this.scrollNavItem( secId );
      if( this.isGlossary ) {
        this.glossaryScrollFunc( secId );
      }
    }
  }

  scrollFunc () {
    const scrollSections = gsap.utils.toArray( this.sections );
    scrollSections.forEach( ( section ) => {
      const secH = section.offsetHeight;
      const startPosition = this.hH + this.navH + 120;
      gsap.to( section, {
        scrollTrigger: {
          trigger: section,
          start: `top ${startPosition}`,
          end: `+=${secH}`,
          scrub: 0.8,
          invalidateOnResize: true,
          onEnter: () => {
            this.setSectionActive( section );
          },
          onEnterBack: () => {
            this.setSectionActive( section );
          },
        }
      } );
    } );
  }

  init () {
    this.nav.style.top = `${this.hH}px`;
    const firstNavId = this.navItems[0].id.split( this.navIdPrefix )[1];
    this.setNavItemActive( firstNavId );
    this.navItemClickEvent();
    this.scrollFunc();
    const locationHash = window.location.hash;
    if( locationHash && this.isGlossary ) {
      this.glossaryHashFunc( locationHash );
    }
    const selectedGlossary = localStorage.getItem( 'selectedGlossary' );
    if( selectedGlossary ) {
      this.navItemClick( selectedGlossary );
    }
    localStorage.removeItem( 'selectedGlossary' );
    let isScrolling;
    window.addEventListener( 'scroll', () => {
      window.clearTimeout( isScrolling );
      isScrolling = setTimeout( () => {
        this.clicked = false;
      }, 150 );
    } );
  }
}

const navEls = document.querySelectorAll( '.e-stn--navigation-tabs' );
const loadHandler = () => {
  if( !navEls ) { return; }
  navEls.forEach( ( navEl ) => {
    const navObj = new NavigationTabs( navEl );
    navObj.init();
  } );
};
window.addEventListener( 'load', loadHandler );
